export type UserTypeFilter = 'commerce' | 'operator' | 'external_operator';

export const USER_TYPE_LABELS: Record<UserTypeFilter, string> = {
  commerce: 'Comercio',
  operator: 'Operador',
  external_operator: 'Operador externo',
};
